import axios from "axios";
import { baseURL } from "../config/api";

export const post_Payment = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}payment?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const post_PaymentFromPaymentRequest = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}payment/MakePaymentFromPaymentRequest`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            userId
        }
    });
    return response.data;
}